import axios from 'axios';
import * as apiURL from './apiConfig';

export const postItemToCart = async (cartData) => {
  try {
    const response = await axios.post(apiURL.CART_URL, cartData);
    return response.data.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getAllCartItems = async () => {
  try {
    const response = await axios.get(apiURL.CART_URL);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const updateCartItem = async ({ cartId, ...rest }) => {
  try {
    const response = await axios.put(`${apiURL.CART_URL}/${cartId}`, rest);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const deleteCartItem = async (cartId) => {
  try {
    const response = await axios.delete(`${apiURL.CART_URL}/${cartId}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getCartCount = async () => {
  try {
    const response = await axios.get(apiURL.CART_COUNT_URL);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const moveToWishlist = async (data) => {
  try {
    const response = await axios.post(apiURL.MOVE_TO_WISHLIST_URL, {
      ...data,
    });
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
